module.exports = __webpack_public_path__ + "img/paso1.a6502b81.svg";